import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

export const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STOREAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDERID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
});

// 只用 signInWithCustomToken，不需要 popup/redirect resolver；
// getAuth 預設會帶上它，使手機與 Safari 初始化時先載入 gapi 與 auth iframe，阻擋 Firestore 啟動
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
});
// 部分行動網路下串流回應會被扣住，直到伺服器 30 秒後的 keepalive 才放出，導致首次載入卡約 30 秒；
// 自動偵測只看是否收到第一個 byte，偵測不到這種情況，因此強制每次回應即結束的 long-polling
export const firestore = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
export const analytics = getAnalytics(app);
